<template>
  <div class="faq">
    <div class="faq-question-s" v-b-toggle.q69>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q69.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q69')}}</b-col>
      </b-row>
      <b-collapse id="q69">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A69.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a69-1')}}</div>
            <br/>
            <div>{{$t('a69-2')}}</div>
            <br/>
            <span class="bd-url" @click="redirectPage()">{{ this.$i18n.locale === 'en' ?
              'https://www.gov.hk/en/about/helpdesk/softwarerequirement/hkscs.htm' : this.$i18n.locale === 'zh_hk' ?
                'https://www.gov.hk/tc/about/helpdesk/softwarerequirement/hkscs.htm' :
                'https://www.gov.hk/sc/about/helpdesk/softwarerequirement/hkscs.htm' }}</span>
            <br />
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q70>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q70.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q70')}}</b-col>
      </b-row>
      <b-collapse id="q70">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A70.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a70-1')}}</div>
            <br/>
            <b-row>
              <b-col cols="10">
                <b-list-group>
                  <b-list-group-item>{{ $t("a70-2") }}</b-list-group-item>
                  <b-list-group-item>{{ $t("a70-3") }}</b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
            <br/>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q71>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q71.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q71')}}</b-col>
      </b-row>
      <b-collapse id="q71">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A71.</b></b-col>
          <b-col cols="11">
            <div v-html="$t('a71-1')"></div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q72>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q72.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q72')}}</b-col>
      </b-row>
      <b-collapse id="q72">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A72.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a72-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirectPage() {
      switch (this.$i18n.locale) {
        case 'en':
          window.open('https://www.gov.hk/en/about/helpdesk/softwarerequirement/hkscs.htm');
          break;
        case 'zh_hk':
          window.open('https://www.gov.hk/tc/about/helpdesk/softwarerequirement/hkscs.htm');
          break;
        case 'zh_cn':
          window.open('https://www.gov.hk/sc/about/helpdesk/softwarerequirement/hkscs.htm')
      }
    }
  }
};
</script>

<i18n src="@/public/locales/modules/faq/components/FaqOther.json" />